var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSummary = function SvgIcSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 30c0-13.807-11.193-25-25-25s-25 11.193-25 25 11.193 25 25 25 25-11.193 25-25Z",
    fill: "#828C97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.255 16.25h-3.511c-.34 0-.677.06-.989.18a2.513 2.513 0 0 0-.827.512 2.18 2.18 0 0 0-.529.761 1.975 1.975 0 0 0-.145.885L27.349 35h6.275l1.121-16.412c.02-.3-.029-.602-.145-.885a2.178 2.178 0 0 0-.53-.76 2.515 2.515 0 0 0-.826-.513 2.768 2.768 0 0 0-.989-.18ZM30.5 45.901a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    fill: "#CFD0D3"
  })));
};
export default SvgIcSummary;